

/**
 * Create a color object from provided color value.
 * Handles three values:
 * rgb(255,0,0) -- with or without spaces
 * #ff0000
 * #f00
 * The returned object has two methods:
 * myColor.toHex()
 * myColor.toRGB()
 *
 * @constructor - Must use new keyword
 * @param {string} color - A hex or rgb value.
 * @return {object} UIColor
 */
const UIColor = function(color) {
  this.ok = false
  /**
   * Check for hex color value.
   * String "#" if found.
   */
  if (color.charAt(0) == '#') {
    color = color.substr(1,6)
  }
  color = color.toLowerCase()


  /**
   * Array of color format regex patterns.
   * These will identify the format of the color provided above.
   * The process function converts hex color values into decimal (rgb).
   */
  const colorRegex = [
    {
      /* Example: ['rgb(123, 234, 45)', 'rgb(255, 234, 245)'] */
      re: /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
      process: function(bits) {
        return [
          parseInt(bits[1]),
          parseInt(bits[2]),
          parseInt(bits[3])
        ]
      }
    },
    {
      /* Example: ['#00ff00', '336699'] */
      re: /^(\w{2})(\w{2})(\w{2})$/,
      process: function(bits) {
        return [
          parseInt(bits[1], 16),
          parseInt(bits[2], 16),
          parseInt(bits[3], 16)
        ]
      }
    },
    {
      /**
       * Example: ['#fb0', 'f0f']
       */
      re: /^(\w{1})(\w{1})(\w{1})$/,
      process: function(bits) {
        return [
          parseInt(bits[1] + bits[1], 16),
          parseInt(bits[2] + bits[2], 16),
          parseInt(bits[3] + bits[3], 16)
        ]
      }
    }
  ]

  /**
   * Check for a match using each regex.
   */
  for (let i = 0; i < 3; i++) {
    const re = colorRegex[i].re
    const processor = colorRegex[i].process
    const bits = re.exec(color)
    if (bits) {
      const channels = processor(bits)
      this.r = channels[0]
      this.g = channels[1]
      this.b = channels[2]
      this.ok = true
    }
  }

  /**
   * Validate/cleanup values.
   */
  this.r = (this.r < 0 || isNaN(this.r)) ? 0 : ((this.r > 255) ? 255 : this.r)
  this.g = (this.g < 0 || isNaN(this.g)) ? 0 : ((this.g > 255) ? 255 : this.g)
  this.b = (this.b < 0 || isNaN(this.b)) ? 0 : ((this.b > 255) ? 255 : this.b)

  this.toHex = () => {
    let r = this.r.toString(16)
    let g = this.g.toString(16)
    let b = this.b.toString(16)
    if (r.length == 1) r = '0' + r
    if (g.length == 1) g = '0' + g
    if (b.length == 1) b = '0' + b
    return '#' + r + g + b
  }

  this.toRGB = function() {
    return 'rgb(' + this.r +',' + this.g + ',' + this.b + ')'
  }
}

$.extend({

  /**
   * Make global method to get brightness of provided color.
   * This is based on the values of YIQ color formula.
   * This method expects a color object created by UIColor.
   */
  getBrightness: (color) => {
    if ($.type(color) === 'string') color = UIColor(color)
    return (color.r * .299) + (color.g * .587) + (color.b * .114)
  },

  /**
   * Function to light a color.
   * Expects a hex value as string and an integer as percent:
   */
  lightenColor: (color, percent) => {
    const num = parseInt(color.slice(1), 16)
    const amt = Math.round(2.55 * percent)
    let R = (num >> 16) + amt
    let G = (num >> 8 & 0x00FF) + amt
    let B = (num & 0x0000FF) + amt
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
  },

  /**
   * Function to darken a color.
   * Expects a hex value as string and an integer as percent:
   */
  darkenColor: (color, percent) => {
    const num = parseInt(color.slice(1), 16)
    const amt = Math.round(2.55 * percent)
    let R = (num >> 16) - amt
    let G = (num >> 8 & 0x00FF) - amt
    let B = (num & 0x0000FF) - amt
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
  },

  /**
   * Method to calculate color contrast.
   * It expects a hex or rgb value:
   */
  calculateBrightness: (color) => {
    if ($.type(color) === 'object') color = color.toHex()
    const kolor = new UIColor(color)
    return $.getBrightness(kolor)
  }
})


$(function() {
  if ($.theme === 'android') {
    $('body').on($.eventStart, 'button, ul.editing > li, li[data-show], li[data-select], li[data-goto], ui-sheet-handle, ui-switch, .ui-popover li', function(e) {
      let target = this
      if (target.hasAttribute("disabled") || target.classList.contains("disabled")) {
        return
      }

      let w = Math.min(this.offsetWidth, 160)
      let h = Math.min(this.offsetHeight, 160)
      const d = Math.max(w, h)
      w = d
      h = d

      const offset = this.getBoundingClientRect()

      const x = $.isAndroid ? e.touches[0].pageX - offset.left : e.pageX - offset.left
      const y = $.isAndroid ? e.touches[0].pageY - offset.top :  e.pageY - offset.top

      let navBkColor
      let backgroundColor

      const ripple = document.createElement('ripple-sheath')
      $(target).append(ripple)

      if (target.nodeName === 'BUTTON' && target.classList.contains('slide-out-button')) {
        let navBkColor = $('ui-screen > nav').eq(0).css('background-color')
        backgroundColor = new UIColor(navBkColor).toHex()
      } else if ((target.nodeName === 'BUTTON' && $(target).closest('nav')[0])) {
        navBkColor = $(target).closest('nav').css('background-color')
        backgroundColor = new UIColor(navBkColor).toHex()

      } else if ((target.nodeName === 'BUTTON' && $(target).closest('toolbar')[0])) {
        navBkColor = $(target).closest('toolbar').css('background-color')
        backgroundColor = new UIColor(navBkColor).toHex()

      } else {
        backgroundColor = $(this).css('background-color')
        if (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)') {
          backgroundColor = '#fff'
        }
      }

      let rippleColor = '#fff'
      const brightness = $.calculateBrightness(backgroundColor)
      if (brightness > 195) {
        rippleColor = '#aaa'
      } else {
        rippleColor = '#fff'
      }

      if (target.dataset.rippleColor) {
        rippleColor = target.dataset.rippleColor
      }

      const rippleWave = document.createElement('ripple-wave')
      rippleWave.style.backgroundColor = rippleColor
      rippleWave.style.width = `${h}px`
      rippleWave.style.height = `${h}px`
      rippleWave.style.left = `${x - (h/2)}px`
      rippleWave.style.top = `${y - (h/2)}px`

      ripple.append(rippleWave)
      setTimeout(function() {
        $(ripple).remove()
      }, 1000)
    })
  }
})


$.extend({

  /**
   * Cover screen:
   */
  block: opacity => {
    if (document.querySelector('ui-mask')) return
    $('body').append(`<ui-mask></ui-mask>`)
    document.querySelector('ui-mask').style.display = 'block'
    setTimeout(function() {
      document.querySelector('ui-mask').classList.add('opened')
      if (opacity) $('ui-mask').css({opacity: opacity})
    })
    const screen = document.querySelector('ui-screen.current')
    if (screen) screen.setAttribute('aria-hidden', true)
  },

  /**
   * Uncover screen:
   */
  unblock: () => {
    $('ui-mask').remove()
    const screen = document.querySelector('ui-screen.current')
    if (screen) screen.removeAttribute('aria-hidden')
  }
})


class UIBusy {
  constructor(options) {
    if (!options) return
    let settings = {
      size: 40,
      color: '#666',
    }
    $.extend(settings, options)
    const element = $(settings.element)

    let spinner
    /**
     * For iOS:
     */
    const iOSBusy = () => {
      let small
      /**
       * Smaller busy indicator (less tines):
       */
      if (parseInt(settings.size, 10) < 30) {
        spinner = `<svg class='chui-busy small' width='${ settings.size }px' height='${ settings.size }px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'>
        <g x='0' y='0' width='100' height='100' fill='none' class='bk'>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(0 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(45 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(90 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(135 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(180 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(225 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(270 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(315 50 50) translate(0 -30)'></rect>
        </g>
      </svg>`
        element.append(spinner)
      /**
       * Larger busy indicator (more tines)
       */
      } else {
        spinner = `<svg class='chui-busy' width='${ settings.size }px' height='${ settings.size }px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' class='uil-default'>
        <g x='0' y='0' width='100' height='100' fill='none'>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(0 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(30 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(60 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(90 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(120 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(150 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(180 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(210 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(240 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(270 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(300 50 50) translate(0 -30)'></rect>
          <rect  x='46.5' y='40' width='7' height='20' rx='5' ry='5' fill='${ settings.color }' transform='rotate(330 50 50) translate(0 -30)'></rect>
        </g>
      </svg>`
        element.append(spinner)
      }
    }

    /**
     * For Android:
     */
    const androidBusy = () => {
      settings.id = $.uuid()
      let androidActivityIndicator = null
      if ($.isNativeAndroid) {
        androidActivityIndicator = `<svg class="chui-busy" version="1.1" id="${ settings.id }" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
        <g>
          <path fill="none" stroke="${ settings.color }" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M74.2,65c2.7-4.4,4.3-9.5,4.3-15c0-15.7-12.8-28.5-28.5-28.5S21.5,34.3,21.5,50c0,5.5,1.6,10.6,4.3,15"/>
        </g>
        <polyline fill="none" stroke="${ settings.color }" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="89.4,56.1 74.3,65 65.4,49.9 "/>
      </svg>`

        element.append(androidActivityIndicator)
        return
      } else {
        androidActivityIndicator = `<svg id="${ settings.id }" class="chui-busy" x="0px" y="0px" viewBox="0 0 100 100"><circle stroke="url(#SVGID_1_)" cx="50" cy="50" r="28.5"/></svg>`
        element.append(androidActivityIndicator)
        element.array[0].classList.add('hasActivityIndicator')
        if (options.color) {
          $('#' + settings.id).find('circle').css('stroke', options.color)
        }
      }
      $('#' + settings.id).css({
        'height': settings.size + 'px',
        'width': settings.size + 'px'
      })
    }

    /**
     * Create Busy control for appropriate OS:
     */
    if ($.theme === 'android') {
      androidBusy(options)
    } else if ($.theme === 'ios') {
      iOSBusy(options)
    }

    this.center = function(position) {
      if (!element) return
      const busy = element.find('.chui-busy')
      const parent = element.array[0]
      if (position) {
        busy.css('position', position)
      } else {
        position = busy.css('position')
      }
      let height
      let width
      let parentHeight
      let parentWidth
      if (position === 'absolute') {
        busy.css('position', 'absolute')
        height = busy.array[0].clientHeight
        width = busy.array[0].clientWidth
        parentHeight = parent.clientHeight
        parentWidth = parent.clientWidth
      } else {
        height = parseInt(busy.css('height'), 10)
        width = parseInt(busy.css('width'), 10)
        parentHeight = parseInt($(parent).css('height'), 10)
        parentWidth = parseInt(($(parent)).css('width'), 10)
        $(busy).css({
          'margin-left': 'auto',
          'margin-right': 'auto'
        })
      }
      let tmpTop
      let tmpLeft
      if (parent.nodeName === 'body') {
        tmpTop = ((window.innerHeight / 2) + window.pageYOffset) - height / 2 + 'px'
        tmpLeft = ((window.innerWidth / 2) - (width / 2) + 'px')
      } else {
        tmpTop = (parentHeight / 2) - (height / 2) + 'px'
        tmpLeft = (parentWidth / 2) - (width / 2) + 'px'
      }
      if (position !== 'absolute') tmpLeft = 0
      busy.css({
        left: tmpLeft,
        top: tmpTop
      })
      return busy
    }

  }
}


/**
 * Class to enable reording list items.
 */
const ReorderList = (function() {
  'use strict'

  const accessibility = {
    list: {
      ariaRole: "listbox",
      tabIndex: 0,
      focus: false
    },
    items: {
      ariaRole: "option",
      tabIndex: -1,
      focus: false
    },
  }

  let FixForChrome = /Chrome\/[3-5]/.test(navigator.userAgent)
  let testElementStyle = document.createElement('div').style
  const transitionJSPropertyName = "transition" in testElementStyle ? "transition" : "webkitTransition"
  const transformJSPropertyName = "transform" in testElementStyle ? "transform" : "webkitTransform"
  const transformCSSPropertyName = transformJSPropertyName === "webkitTransform" ? "-webkit-transform" : "transform"
  const userSelectJSPropertyName = "userSelect" in testElementStyle ? "userSelect" : "webkitUserSelect"
  let hwLayerMagicStyle = testElementStyle[transformJSPropertyName] ? 'translateZ(0) ' : ''
  let hwTopLayerMagicStyle = testElementStyle[transformJSPropertyName] ? 'translateZ(1px) ' : ''
  testElementStyle = null

  let globalInstances = 0
  let attachedBodyHandlerHack = false

  function ReorderList(list, options) {
    list = document.querySelector(list)
    if (!this || this === window) return new ReorderList(list, options)
    this.options = options = options || {}
    this.onTouchCancel = this.setState.bind(this, this.states.idle)
    this.onTouchEnd = this.onTouchEnd.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onSelection = this.onSelection.bind(this)
    this.onContainerFocus = this.onContainerFocus.bind(this)
    this.onEventStart = this.onEventStart.bind(this)
    this.onEventMove = this.onEventMove.bind(this)
    this.setState(this.states.idle)
    this.attach(list)

    $(list).on('reorder:reorder', function(e) {
      if (!this.classList.contains('showIndicators')) {
        return
      }
      e.target.parentNode.insertBefore(e.target, e.detail.insertBefore)
      return false
    }, false)
  }

  function getTransform(node) {
    const transform = node.style[transformJSPropertyName]
    if (transform) {
      return {
        value:transform,
        original:transform,
      }
    }
    if (window.getComputedStyle) {
      let style = window.getComputedStyle(node).getPropertyValue(transformCSSPropertyName)
      if (style && style !== 'none') return {value:style, original:''}
    }
    return {value:'', original:''}
  }

  ReorderList.prototype = {

    list: null,
    options: {},
    state: null,
    target: null,
    usingTouch: false,
    mouseHandlersAttached: false,
    startPosition: null,
    latestPosition: null,
    previousPosition: null,
    canPreventScrolling: false,
    states: {
      idle: function idleStateInit() {
        // if(this.list && !this.list.classList.contains('showIndicators')) return
        this.removeMouseHandlers()
        if (this.target) {
          this.target.node.style.willChange = ''
          this.target = null
        }
        this.usingTouch = false

        return {
          allowTextSelection: true,
        }
      },

      undecided: function undecidedStateInit() {
        // if(!this.list.classList.contains('showIndicators')) return
        this.target.height = this.target.node.offsetHeight
        this.target.node.style.willChange = transformCSSPropertyName
        this.target.node.style[transitionJSPropertyName] = ''

        let holdTimer = setTimeout(function() {
          const move = this.getAbsoluteMovement()
          if (this.canPreventScrolling && move.x < 15 && move.y < 25) {
            this.setState(this.states.reorder)
          }
        }.bind(this), 300)

        return {
          leaveState: function() {
            clearTimeout(holdTimer)
          },

          onMove: function() {
            const move = this.getAbsoluteMovement()
            if (move.x > 20 && move.y < Math.max(100, this.target.height)) {
              this.setState(this.states.idle)
            }
            if (move.y > 20) {
              this.setState(this.states.idle)
            }
            if (move.x > move.y*1.2) return false
          },

          onLeave: function() {
            this.setState(this.states.idle)
          },

          onEnd: function() {
            const allowDefault = this.dispatch(this.target.originalTarget, 'tap')
            this.setState(this.states.idle)
            return allowDefault
          },
        }
      },

      reorder: function reorderStateInit() {
        if (this.target.node.focus && accessibility.items.focus) {
          this.target.node.focus()
        }
        this.target.height = this.target.node.offsetHeight
        const nodes = this.list.childNodes
        let originalIndex = $(this.target).index()
        let mouseOutsideTimer
        const zero = this.target.node.offsetTop + this.target.height/2
        const otherNodes = []
        for(let i = 0; i < nodes.length; i++) {
          if (nodes[i].nodeType != 1 || nodes[i] === this.target.node) continue
          const t = nodes[i].offsetTop
          nodes[i].style[transitionJSPropertyName] = transformCSSPropertyName + ' 0.2s ease-in-out'
          otherNodes.push({
            node: nodes[i],
            baseTransform: getTransform(nodes[i]),
            pos: t + (t < zero ? nodes[i].offsetHeight : 0) - zero,
          })
        }

        this.target.node.classList.add('reordering-list-item')
        this.target.node.style.zIndex = '99999'
        this.target.node.style[userSelectJSPropertyName] = 'none'
        if (FixForChrome) {
          this.list.style.webkitTransformStyle = 'preserve-3d'
        }

        function onMove() {
          this.updateScrolling()
          if (mouseOutsideTimer) {
            clearTimeout(mouseOutsideTimer)
            mouseOutsideTimer = null
          }
          const move = this.getTotalMovement()
          this.target.node.style[transformJSPropertyName] = 'translate(0,' + move.y + 'px) ' + hwTopLayerMagicStyle + this.target.baseTransform.value
          const height = this.target.height
          otherNodes.forEach(function(o) {
            let off = 0
            if (o.pos < 0 && move.y < 0 && o.pos > move.y) {
              off = height
            }
            else if (o.pos > 0 && move.y > 0 && o.pos < move.y) {
              off = -height
            }
            o.node.style[transformJSPropertyName] = off ? 'translate(0,'+off+'px) ' + hwLayerMagicStyle + o.baseTransform.value : o.baseTransform.original
          })


          return false
        }

        onMove.call(this)

        return {
          leaveState: function() {
            if (mouseOutsideTimer) clearTimeout(mouseOutsideTimer)
            if (FixForChrome) {
              this.list.style.webkitTransformStyle = ''
            }
            if (this.list.focus && accessibility.list.focus) {
              this.list.focus()
            }
            this.target.node.classList.remove('reordering-list-item')
            this.target.node.style[userSelectJSPropertyName] = ''
            this.animateToZero(function(target) {
              target.node.style.zIndex = ''
            })
            otherNodes.forEach(function(o) {
              o.node.style[transformJSPropertyName] = o.baseTransform.original
              o.node.style[transitionJSPropertyName] = ''
            })
          },

          onMove: onMove,

          onLeave: function() {
            if (mouseOutsideTimer) clearTimeout(mouseOutsideTimer)
            mouseOutsideTimer = setTimeout(function() {
              mouseOutsideTimer = null
              this.onTouchCancel()
            }.bind(this), 700)
          },

          onEnd: function() {
            const move = this.getTotalMovement()
            let i
            let spliceIndex
            if (move.y < 0) {
              for (i = 0; i < otherNodes.length; i++) {
                if (otherNodes[i].pos > move.y) {
                  break
                }
              }
              spliceIndex = i
            } else {
              for (i = otherNodes.length-1; i >= 0; i--) {
                if (otherNodes[i].pos < move.y) {
                  break
                }
              }
              spliceIndex = i+1
            }

            this.dispatch(this.target.node, 'reorder', {spliceIndex:spliceIndex, insertBefore:otherNodes[spliceIndex] ? otherNodes[spliceIndex].node : null, originalIndex: originalIndex})
            this.setState(this.states.idle)
            return false
          },
        }
      },
    },

    attach: function(list) {
      globalInstances++
      if (this.list) this.detach()
      if (!attachedBodyHandlerHack && FixForChrome) {
        attachedBodyHandlerHack = true
        document.body.addEventListener('touchstart', $.noop, false)
      }

      this.list = list

      if (false !== accessibility.list.tabIndex) {
        this.list.tabIndex = accessibility.list.tabIndex
      }
      if (accessibility.list.ariaRole) {
        this.list.setAttribute('aria-role', accessibility.list.ariaRole)
      }
      this.setChildNodesAriaRoles()
      this.list.addEventListener('focus', this.onContainerFocus, false)
      this.otherNodes = []

      $(document).on("selectionchange", this.onSelection, false)
      $(this.list).on('touchcancel', this.onTouchCancel, false)
      $(this.list).on('touchend', this.onTouchEnd, false)
      $(this.list).on($.eventStart, this.onEventStart, false)
      $(this.list).on($.eventMove, this.onEventMove, false)
    },

    detach: function() {
      this.onTouchCancel()
      $(document).off("selectionchange", this.onSelection, false)
      $(this.list).off('touchcancel', this.onTouchCancel, false)
      $(this.list).off('touchend', this.onTouchEnd, false)
      $(this.list).off($.eventMove, this.onEventMove, false)

      if (false !== accessibility.list.tabIndex) {
        this.list.removeAttribute('tabIndex')
      }
      if (accessibility.list.ariaRole) {
        this.list.removeAttribute('aria-role')
      }
      this.unSetChildNodesAriaRoles()

      globalInstances--
      if (!globalInstances && attachedBodyHandlerHack) {
        attachedBodyHandlerHack = false
        $('body').off('touchstart', $.noop, false)
      }
    },

    setState: function(newStateCtor) {
      if(this.list && !this.list.classList.contains('showIndicators')) return

      if (this.state) {
        if (this.state.ctor === newStateCtor) return
        if (this.state.leaveState) this.state.leaveState.call(this)
      }
      let prevState = this.state
      let nextState = newStateCtor.call(this)
      if (this.state === prevState) {
        nextState.ctor = newStateCtor
        this.state = nextState
      }
    },

    findTargetNode: function(targetNode) {
      while(targetNode && targetNode.parentNode !== this.list) {
        targetNode = targetNode.parentNode
      }
      return targetNode
    },

    onContainerFocus: function(e) {
      if(!this.list.classList.contains('showIndicators')) return
      this.list.style.outline = 'none'
      this.setChildNodesAriaRoles()
    },

    setChildNodesAriaRoles: function() {
      const self = this
      const nodes = Array.prototype.slice.call(self.list.childNodes)
      for(let i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeType != 1) continue
        if (accessibility.items.ariaRole) {
          nodes[i].setAttribute('aria-role', accessibility.items.ariaRole)
        }
        if (false !== accessibility.items.tabIndex) {
          nodes[i].tabIndex = accessibility.items.tabIndex
        }
      }
    },

    unSetChildNodesAriaRoles: function() {
      const nodes = Array.prototype.slice.call(self.list.childNodes)
      for(let i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeType != 1) continue
        if (accessibility.items.ariaRole) {
          nodes[i].removeAttribute('aria-role')
        }
        if (false !== accessibility.items.tabIndex) {
          nodes[i].removeAttribute('tabIndex')
        }
      }
    },
    onSelection: function(e) {
      const isRelated = e.target === document || this.findTargetNode(e)
      const iOS = /(iPhone|iPad|iPod)/i.test(navigator.userAgent) && !/(Android|Windows)/i.test(navigator.userAgent)
      if (!isRelated) return

      if (iOS) {
        this.setState(this.states.idle)
      } else {
        if (!this.state.allowTextSelection) {
          e.preventDefault()
        }
      }
    },

    addMouseHandlers: function() {
      if (!this.mouseHandlersAttached) {
        this.mouseHandlersAttached = true
        $(document).on('mouseleave', this.onMouseLeave, false)
        $(document).on('mouseup', this.onMouseUp, true)
        $(document).on('blur', this.onTouchCancel, false)
      }
    },

    removeMouseHandlers: function() {
      if (this.mouseHandlersAttached) {
        this.mouseHandlersAttached = false
        $(document).off('mouseleave', this.onMouseLeave, false)
        $(document).off('mouseup', this.onMouseUp, true)
        $(document).off('blur', this.onTouchCancel, false)
      }
    },

    onMouseLeave: function(e) {
      if (this.usingTouch) return
      if (e.target === document.documentElement || e.relatedTarget === document.documentElement) {
        if (this.state.onLeave) {
          this.state.onLeave.call(this)
        }
      }
    },

    onEventStart: function(e) {
      if ($.isTouchEnabled) {
        this.usingTouch = true
        this.canPreventScrolling = true
        if (e.touches.length > 1) {
          this.setState(this.states.idle)
          return
        }
        if (!this.setTarget(e)) return
        this.startAtPosition({
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          time: e.timeStamp
        })
      } else {
        if (this.usingTouch || e.button != 0 || !this.setTarget(e)) return
        this.addMouseHandlers()
        this.canPreventScrolling = true
        this.startAtPosition({
          x: e.clientX,
          y: e.clientY,
          time: e.timeStamp
        })
      }
    },

    setTarget: function(e) {
      const targetNode = this.findTargetNode(e.target)
      if (!targetNode) {
        this.setState(this.states.idle)
        return false
      }
      let scrollContainer = targetNode.parentNode
      while (scrollContainer) {
        if (scrollContainer == document.body) break
        if (scrollContainer.scrollHeight > scrollContainer.clientHeight && window.getComputedStyle(scrollContainer)['overflow-y'] != 'visible') break
        scrollContainer = scrollContainer.parentNode
      }
      scrollContainer = scrollContainer || document.body

      this.target = {
        originalTarget: e.target,
        node: targetNode,
        scrollContainer: scrollContainer,
        origScrollTop: scrollContainer.scrollTop,
        origScrollHeight: scrollContainer.scrollHeight,
        baseTransform: getTransform(targetNode)
      }
      return true
    },

    startAtPosition: function(pos) {
      this.startPosition = this.previousPosition = this.latestPosition = pos
      this.setState(this.states.undecided)
    },

    updatePosition: function(e, pos) {
      if (this.target == null) {
        return
      }
      this.latestPosition = pos

      if (this.state.onMove) {
        if (this.state.onMove.call(this) === false) {
          e.preventDefault()
        }
      }
      if (this.latestPosition.time - this.previousPosition.time > 100) {
        this.previousPosition = this.latestPosition
      }
    },

    onEventMove: function(e) {
      if ($.isTouchEnabled) {
        this.updatePosition(e, {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          time: e.timeStamp
        })
        this.canPreventScrolling = false
      } else {
        this.updatePosition(e, {
          x: e.clientX,
          y: e.clientY,
          time: e.timeStamp
        })
      }
    },

    onMouseUp: function(e) {
      if (this.usingTouch || e.button !== 0) return

      if (this.state.onEnd && false === this.state.onEnd.call(this)) {
        e.preventDefault()
      }
    },

    onTouchEnd: function(e) {
      if (e.touches.length > 1) {
        this.onTouchCancel()
      } else if (this.state.onEnd && false === this.state.onEnd.call(this)) {
        e.preventDefault()
      }
    },

    getTotalMovement: function() {
      const scrollOffset = this.target.scrollContainer.scrollTop - this.target.origScrollTop
      return {
        x: this.latestPosition.x - this.startPosition.x,
        y: this.latestPosition.y - this.startPosition.y + scrollOffset,
        time: this.latestPosition.time - this.startPosition.time,
      }
    },

    getAbsoluteMovement: function() {
      const move = this.getTotalMovement()
      return {
        x: Math.abs(move.x),
        y: Math.abs(move.y),
        time: move.time,
        directionX: move.x < 0 ? 'left' : 'right',
        directionY: move.y < 0 ? 'up' : 'down'
      }
    },

    updateScrolling: function() {
      const triggerOffset = 40
      let offset = 0

      const scrollable = this.target.scrollContainer,
        containerRect = scrollable.getBoundingClientRect(),
        targetRect = this.target.node.getBoundingClientRect(),
        bottomOffset = Math.min(containerRect.bottom, window.innerHeight) - targetRect.bottom,
        topOffset = targetRect.top - Math.max(containerRect.top, 0),
        maxScrollTop = this.target.origScrollHeight - Math.min(scrollable.clientHeight, window.innerHeight)

      if (bottomOffset < triggerOffset) {
        offset = Math.min(triggerOffset, triggerOffset - bottomOffset)
      }
      else if (topOffset < triggerOffset) {
        offset = Math.max(-triggerOffset, topOffset - triggerOffset)
      }
      scrollable.scrollTop = Math.max(0, Math.min(maxScrollTop, scrollable.scrollTop + offset))
    },

    dispatch: function(targetNode, eventName, data) {
      let event = document.createEvent('CustomEvent')
      if (event && event.initCustomEvent) {
        event.initCustomEvent('reorder:' + eventName, true, true, data)
      } else {
        event = document.createEvent('Event')
        event.initEvent('reorder:' + eventName, true, true)
        event.data = data
      }
      return targetNode.dispatchEvent(event)
    },

    animateToZero: function(callback, target) {
      target = target || this.target

      target.node.style[transitionJSPropertyName] = transformCSSPropertyName + ' 0.1s ease-out'
      target.node.style[transformJSPropertyName] = 'translate(0,0) ' + hwLayerMagicStyle + target.baseTransform.value
      setTimeout(function() {
        target.node.style[transitionJSPropertyName] = ''
        target.node.style[transformJSPropertyName] = target.baseTransform.original
        if (callback) callback.call(this, target)
      }.bind(this), 101)
    }
  }
  return ReorderList
})()
/**
 * ChocolateChip-UI Widget - Edit List.
 */
class UIEditList {
  constructor(options) {
    if (!options) return
    const self = this
    let settings = {
      element: undefined,
      editLabel: 'Edit',
      doneLabel: 'Done',
      deleteLabel: 'Delete',
      cancelLabel: 'Cancel',
      callback: $.noop,
      deletable: false,
      reorderable: false,
      state: undefined,
      stateProp: 'id'
    }
    $.extend(settings, options)

    let deletionIndicator = html`
      <aside class="deletion-indicator">
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="deletion-indicator">
              <g id="ios-indicator">
                <circle id="ios-circle" fill="#FF0000" cx="10" cy="10" r="10"></circle>
                <path d="M3.5,10 L16.5,10" id="ios-bar" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square"></path>
              </g>
              <path d="M2,13 L9.9294326,16.8406135 L17.1937075,1.90173332" id="checkmark" stroke="#FA0303" stroke-width="2"></path>
            </g>
          </g>
        </svg>
      </aside>`

    let deleteButton = html`
      <button class="delete">
        <label>${ settings.deleteLabel }</label>
        <svg width="27px" height="30px" viewBox="0 0 27 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="delete-icon" fill="#3A3A3A">
              <g transform="translate(3.000000, 1.000000)">
                <path d="M1,6 L20,6 L20,24.9986131 C20,26.6562333 18.6639569,28 16.9998779,28 L4.00012207,28 C2.3432004,28 1,26.6569187 1,24.9986131 L1,6 Z M4,9 L5,9 L5,25 L4,25 L4,9 Z M8,9 L9,9 L9,25 L8,25 L8,9 Z M12,9 L13,9 L13,25 L12,25 L12,9 Z M16,9 L17,9 L17,25 L16,25 L16,9 Z" id="can"></path><path d="M0,4.96611425 L0,1.67759301 L5.1776507,1.7511163 L6.482399,0 L14.5847825,0 L15.8789491,1.7511163 L21,1.7511163 L21,4.9447157 L0,4.96611425 L0,4.96611425 Z" id="lid"></path>
              </g>
            </g>
          </g>
        </svg>
      </button>`

    let moveHandle = html`
      <svg class='handle' width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: rgba(255,255,255,0.01)">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" stroke="#C7C7CC">
            <g id="Move-Indicator-iOS" transform="translate(2.000000, 5.000000)">
              <path d="M0,0.5 L15,0.5" id="Line-1"></path>
              <path d="M0,3.5 L15,3.5" id="Line-2"></path>
              <path d="M0,6.5 L15,6.5" id="Line-3"></path>
            </g>
          </g>
        </g>
      </svg>`

    let __data = []
    let __editMade = false
    this.callback = settings.callback || $.noop

    if (!settings.deletable && !settings.reorderable) {
      return
    }

    if (options) $.extend(settings, options)

    // let editButton
    let button
    let dispelDeletable = 'swiperight'
    let enableDeletable = 'swipeleft'
    let moveUpIndicator
    let moveDownIndicator
    let element = settings.element
    let deleteLabel
    this.root = $(settings.element)

    if (settings.deletable) {
      document.querySelector(settings.element).classList.add('deletable')
    }
    if (settings.reorderable) {
      document.querySelector(settings.element).classList.add('reorderable')
    }

    if (options.state) options.state.boundComponents.push(this)

    this.render = function(data) {
      let temp = ''
      if (!settings.element) {
        return
      }

      if (!data && settings.state) {
        data = settings.state.dataStore
      }

      if (Array.isArray(data)) {
        data.map(function(item) {
          temp += settings.render(item)
        })
      } else {
        return
      }

      this.root.textContent = ''
      let root = $(settings.element)
      root.empty()
      root.append(temp)
      root.find('li').array.map(li => {
        if (settings.deletable) {
          $(li).prepend(deletionIndicator)
          $(li).append(deleteButton)
        }
        if (settings.reorderable) {
          $(li).append(moveHandle)
        }
      })
    }

    this.val = () => options.state.dataStore

    $(() => {

      /**
       * Handle deletion of list item.
       */
      function deleteListItem(el) {
        let root = $(settings.element)
        let $this = this
        __editMade = true
        let listItem = $($this).closest('li')

        /**
         * Mark list as edited:
         */
        root[0].dataset.listEdit = 'true'
        let direction = '-1200%'
        if (document.querySelector('html').getAttribute('dir') === 'rtl') direction = '1000%'
        $($this).siblings().css({
          '-webkit-transform': 'translate3d(' + direction + ',0,0)',
          '-webkit-transition': 'all 1s ease-out',
          'transform': 'translate3d(' + direction + ',0,0)',
          'transition': 'all 1s ease-out'
        })
        setTimeout(function () {
          listItem.remove()
        }, 500)

      }
      /**
       * Handle moving list item.
       */
      if (settings.reorderable) {
        let reorderList =  new ReorderList(settings.element)
      }

      $(settings.element).on('tap', '.delete', deleteListItem)
    })

    let dir = document.dir
    dir = dir ? dir.toLowerCase() : ''
    if (dir === 'rtl') {
      dispelDeletable = 'swipeleft'
      enableDeletable = 'swiperight'
    }


    let editButton = `<button class="edit">${ settings.editLabel }</button>`
    let screen = $(settings.element).closest('ui-screen')
    let nav = screen.find('nav')
    // console.dir(settings.element)
    // console.dir('ui-screen')
    nav.append(editButton)
    nav.find('.back').hide()
    nav.prepend(`<button class="cancel">${ settings.cancelLabel }</button>`)
    nav.find('.cancel').hide()
    let editBtn = $(settings.element).closest('ui-screen').find('nav .edit')
    let cancelBtn = $(settings.element).closest('ui-screen').find('nav .cancel')
    $(settings.element).on('tap', '.deletion-indicator', function() {
      this.parentNode.classList.toggle('selected')
    })
    editBtn.on('tap', function () {
      let $this = this
      /**
       * When button is in "Edit" state:
       */
      let cancelBtn = $this.parentNode.querySelector('.cancel')
      if (this.classList.contains('edit')) {
        setTimeout(function () {
          $this.classList.remove('edit')
          $this.classList.add('done')
          $($this).text(settings.doneLabel)
          document.querySelector(settings.element).classList.add('showIndicators')
          let backBtn = $this.parentNode.querySelector('.back')
          $(backBtn).hide()
          $(cancelBtn).css('display', 'block')

        })

        /**
         * When button is in "Done" state:
         */
      } else if (this.classList.contains('done')) {
        /**
         * Execute callback if edit was performed:
         */
        setTimeout(function () {
          $this.classList.remove('done')
          $this.classList.add('edit')
          $($this).text(settings.editLabel)
          let list = document.querySelector(settings.element)
          list.classList.remove('showIndicators')
          let selectedItems = $(settings.element + ' li.selected')
          selectedItems.forEach(function(li) {
            li.classList.remove('selected')
          })
          $(cancelBtn).css('display', 'none')
        })

        if (!__editMade) return
        let movedItems = []

        /**
         * Reorder model based on user choice:
         */
        if (settings.state) {
          // (function () {
            let __data = settings.state.dataStore
            let __newarray = []
            let liData = $(settings.element).find('li')
            let temp = []
            liData.array.map(item => {
              temp.push(item.dataset.id)
            })
            temp.forEach(item => {
              let found = __data.find(li => {
                return li.uuid === item
              })
              __newarray.push(found)
            })
            settings.state.purge()
            settings.state.replace(__newarray)
            __newarray = []
          // })()

          self.callback.call(self, self.callback)
        }
      }
    })
    cancelBtn.on('tap', function() {
      let $this = this
      let editBtn = $(settings.element).closest('ui-screen').find('nav .done')
      editBtn.text(settings.editLabel)
      editBtn.array[0].classList.remove('done')
      editBtn.array[0].classList.add('edit')
      setTimeout(function () {
        document.querySelector(settings.element).classList.remove('showIndicators')
        let backBtn = $this.parentNode.querySelector('.back')
        $(backBtn).show()
        $($this).css('display', 'none')
      })
    })
  }
}


class UIMultiSelectList {
  constructor(options) {
    if (!options || !options.element) return
    const self = this
    let settings = {
      element: undefined,
      selected: [],
      name: $.uuid() + '[]',
      callback: $.noop,
      state: undefined
    }
    this.selection = []
    $.extend(settings, options)
    let selections = settings.selected
    const name = settings.name
    const list = $(settings.element)
    const selectionIndicator = function(value) {
      return`<aside>
        <span class="multi-selection-indicator">
          <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="multi-select-icon" stroke="#979797">
              <g id="multi-select-circle-+-multi-select-checkmark" transform="translate(2.000000, 2.000000)">
                <circle id="multi-select-circle" cx="13" cy="13" r="13"></circle>
                <path d="M4.71521456,15.9877529 L13.0000002,20.7028494 L19.977049,5.70284941" id="multi-select-checkmark"></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </aside>`
    }
    if (settings.state) {
      settings.state.boundComponents.push(this)
    }

    // this.val = () => __selection


    this.render = function(data, append) {
      var temp = ''
      if (!settings.element) {
        return
      }

      if (!data && settings.state) {
        data = settings.state.dataStore
      }

      if (Array.isArray(data)) {
        data.map(function(item, idx) {
          temp += settings.render(item)
        }).join('')
      } else {
        return
      }

      var root = $(settings.element)
      root.array[0].classList.add('multi-select-list')
      root.empty()
      root.append(temp)
      setTimeout(function() {
        var data = settings.state.dataStore
        var listItems = Array.prototype.slice.apply(root[0].querySelectorAll('li'))
        listItems.map((item, idx) => {
          item.dataset.select = data[idx].value
          if (settings.selected && settings.selected.length) {
            if (settings.selected.indexOf(idx) > -1) {
              item.classList.add('selected')

              self.selection.push({
                index: idx,
                value: data[idx].value
              })
              $(item).append(`<input type="checkbox" checked name="${ name }" value="${ data[idx].value }">`)
            } else {
              $(item).append(`<input type="checkbox" name="${ name }" value="${ data[idx].value }">`)
            }
          } 
          $(item).prepend(selectionIndicator(data[idx][settings.value]))
          
        })
      })
    }

    list.on('tap', 'li', function() {
      const item = this
      if (item.classList.contains('selected')) {
        item.classList.remove('selected')
        item.removeAttribute('aria-checked')
        item.querySelector('input').checked = false
        let dataObj = {
          index: $(item).index(),
          value: item.dataset.select
        }
        let pos
        self.selection.forEach(function(item, idx) {
          if (item.value === dataObj.value) {
            pos = idx
          }
        })

        self.selection.splice(pos, 1)
        settings.callback.apply(this, arguments)

      } else {
        self.selection.push({
          index: $(item).index(),
          value: item.dataset.select
        })
        self.selection.unique()
        item.classList.add('selected')
        item.setAttribute('aria-checked', true)
        item.querySelector('input').checked = true
        settings.callback.apply(this, arguments)
      }
    })
  }
}


$(() => {
  const chuiBackButtonSVG = `<svg id="chui-back-button-svg" width="100px" height="100px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="chui-back-arrow" stroke="#979797">
        <path d="M50.7822487,4.05872022 L5.60302012,49.1913445 L50.4625593,94.6779982" id="back-arrow-bracket"></path>
        <path d="M6,49.368351 L95.8300018,49.368351" id="back-arrow-shaft"></path>
      </g>
    </g>
  </svg>`

  $.fn.extend({
    decorateBackButton: function() {
      this.forEach(button => {
        if (button.classList.contains('back') || button.classList.contains('backTo')) {
          const buttonText = button.textContent.trim()
          button.innerHTML = `<span>${ buttonText }</span>`
          $(button).prepend(chuiBackButtonSVG)
        }
      })
    }
  })
  $(function () {
    $('.back').decorateBackButton()
    $('.backTo').decorateBackButton()
  })

  let isNavigating = false
  const getScreen = screen => $('#' + screen).array[0]

  const makeScreenCurrent = screen => {
    if (!screen) return
    screen.classList.add('current')
    screen.classList.remove('previous')
    screen.classList.remove('next')
  }
  const makeScreenPrevious = screen => {
    if (!screen) return
    screen.classList.remove('current')
    screen.classList.remove('next')
    screen.classList.add('previous')
  }
  const makeScreenNext = screen => {
    if (!screen) return
    screen.classList.remove('current')
    screen.classList.remove('previous')
    screen.classList.add('next')
  }

  $.extend({

    /**
     * Navigate to Specific Article
     */
    GoTo: destination => {
      if ($.isNavigating) return
      $.isNavigating = true
      setTimeout(function () {
        $.isNavigating = false
      }, 500)
      $.ChuiRoutes.push(destination)
      const currentScreen = $('ui-screen.current').array[0]
      const destinationScreen = function () {
        let temp
        const regex = /:/img
        temp = regex.test(destination) ? destination.split(':')[0] : destination
        return getScreen(temp)
      }()
      if (currentScreen) currentScreen.scrollTop = 0
      if (destinationScreen) destinationScreen.scrollTop = 0
      makeScreenPrevious(currentScreen)
      makeScreenCurrent(destinationScreen)
      Router.dispatch(destination)
    },

    /**
     * Navigate Back to Previous Article
     */
    GoBack: () => {
      if ($.isNavigating) return
      $.isNavigating = true
      const currentScreen = $('ui-screen.current').array[0]
      $.ChuiRoutes.pop()
      const destination = $.ChuiRoutes[$.ChuiRoutes.length - 1]
      const destinationScreen = function () {
        let temp
        const regex = /:/img
        temp = regex.test(destination) ? destination.split(':')[0] : destination
        return getScreen(temp)
      }()
      if (currentScreen[0]) currentScreen[0].scrollTop = 0
      if (destinationScreen[0]) destinationScreen[0].scrollTop = 0
      makeScreenNext(currentScreen)
      makeScreenCurrent(destinationScreen)
      Router.dispatch(destination)
      setTimeout(function () {
        $.isNavigating = false
      }, 500)
    },

    isNavigating: false,

    /**
     * Navigate Back to Non-linear Article
     */
    GoBackTo: destination => {
      const position = $.ChuiRoutes.findIndex(function(dest) {
        return dest = destination
      })
      const destinationScreen = getScreen(destination)
      while ($.ChuiRoutes.length > position + 1) {
        let route = $.ChuiRoutes.pop()
        route = route.split(':')[0]
        let screen = getScreen(route)
        makeScreenNext(screen)
      }
      makeScreenCurrent(destinationScreen)
      Router.dispatch(destination)
    }
  })

  /**
   * Initialize Back Buttons:
   */
  $('body').on('tap', '.back', function () {
    if (this.hasAttribute('disabled')) return
    $.GoBack()
  })

  /**
   * Handle navigation events:
   */
  const handleNavigationEvent = element => {
    if ($.isNavigating) return
    if (!element.dataset.goto) return
    if ($(element).closest('ul').is('.deletable')) return
    let destination = element.dataset.goto
    // console.log(destination)
    if (!destination) return
    element.classList.add('selected')
    setTimeout(() => element.classList.remove('selected'), 1000)
    /**
     * Handle navigation:
     */
    $.GoTo(destination)
  }

  $('body').on('tap', 'li', function () {
    handleNavigationEvent(this)
  })
  
  $('body').on('doubletap', 'li', function () {
    if (!$.isNavigating) {
      handleNavigationEvent(this)
    }
  })
  const globalNav = html`<nav id='global-nav'></nav>`
  $('body').prepend(globalNav)
})


/**
 * Paging control.
 * const options = {
 *   element: selector,
 *   screen: '#main',
 *   data: collection[],
 *   size: 3
 * }
 */
class UIPaging {
  constructor(options) {
    if (!options) return
    const pagingControls = `
      <div class="pager" id='paging-controls'>
        <button class="previous" id='paging-previous' disabled>
          <svg width="24px" height="36px" viewBox="0 0 24 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="pagination-icons" stroke="#979797"><path d="M19.7729197,3 L4.25431067,17.8699971 L19.7729196,32.9558941" id="page-previous"></path></g></g></svg>
        </button>
        <button class="next" id='paging-next'>
          <svg width="24px" height="36px" viewBox="0 0 24 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="pagination-icons" stroke="#979797"><path d="M4.08862955,3.06871359 L20.0261609,18.0528447 L4.08862956,32.9999994" id="page-next"></path></g></g></svg>
        </button>
      </div>`;
    const settings = {}
    $.extend(settings, options)
    const screen = $(settings.screen);
    screen.find('nav').append(pagingControls)
    const chunks = $.chunk(settings.data, settings.size)

    /**
     * Setup buttons for paging.
     */
    $(() => {
      $('#paging-next').on($.eventStart, function() {
        if (this.disabled) return
        const currPage = document.querySelector('article.current')
        if (!currPage) return
        const nextPage = currPage.nextElementSibling
        if (nextPage && nextPage.className === 'next') {
          currPage.classList.add('previous')
          currPage.classList.remove('current')
          nextPage.classList.add('current')
          nextPage.classList.remove('next')
          document.getElementById('paging-previous').removeAttribute('disabled')
          if (!nextPage.nextElementSibling || !nextPage.nextElementSibling.classList.contains('next')) {
            this.disabled = true
          }
        }
      })
      $('#paging-previous').on($.eventStart, function() {
        if (this.disabled) return
        const currPage = document.querySelector('article.current')
        if (!currPage) return
        const nextPage = currPage.previousElementSibling
        if (nextPage && nextPage.className === 'previous') {
          currPage.classList.add('next')
          currPage.classList.remove('current')
          nextPage.classList.add('current')
          nextPage.classList.remove('previous')
          document.getElementById('paging-next').removeAttribute('disabled')
          if (!nextPage.previousElementSibling || !nextPage.previousElementSibling.classList.contains('previous')) {
            this.disabled = true
          }
        }
      })

    })

    this.render = function() {
      let temp = ''
      if (Array.isArray(chunks)) {

        temp = settings.render(chunks)

      } else {
        return
      }
      const root = $(settings.screen).find('section')
      root.empty()
      root.append(temp)
    }

  }
}


class UIPopover {
  constructor(options) {
    if (!options) return
    /**
      id: myUniqueID,
      title: 'Great',
      callback: myCallback,
    */
    options = options || {}
    let settings = {
      id: $.uuid(),
      callback: $.noop,
      title: '',
    }
    $.extend(settings, options)
    if (options && options.content) {
      settings.content = options.content
    } else {
      settings.content = ''
    }
    const header = `<header><h1>${ settings.title }</h1></header>`
    const popover = `<ui-popover id="${ settings.id }">${ header }<section></section></ui-popover>`
    const popoverID = '#' + settings.id

    var side = document.dir === 'rtl' ? 'right' : 'left'

    this.open = function() {
      $.block('.5')
      if (document.body.classList.contains('themeIsAndroid')) {
        document.getElementById(settings.id).style.display = 'block'
        setTimeout(() => {
          document.getElementById(settings.id).classList.add('opened')
          $.positionPopover(settings.trigger)
        })
      } else {
        document.getElementById(settings.id).style.display = 'block'
        document.getElementById(settings.id).classList.add('opened')
        $.positionPopover(settings.trigger)
      }
    }

    $('body').append(popover)
    $(popoverID)[0].dataset.triggerEl = settings.trigger
    $(popoverID).find('section').append(settings.content)
    settings.callback.call(settings.callback, settings.trigger)

  }
}

$.extend({
  positionPopover: element => {
    const el = document.querySelector(element)
    let left = el.offsetLeft
    let calcLeft
    let calcTop
    let po = $('ui-popover.opened')
    calcLeft = po.array[0].offsetLeft
    calcTop = el.offsetTop + el.clientHeight

    if (document.dir === 'rtl') {
      if ((po.array[0].clientWidth + el.offsetLeft) > window.innerWidth) {
        po.css({
          left: (po.array[0].clientLeft - 20) + 'px',
          'top': (calcTop) + 25 + 'px'
        })
      } else {
        if (el.offsetLeft < 250) {
          po.css({
            left: 20 + 'px',
            'top': (calcTop + 25) + 'px'
          })
        } else {
          po.css({
            left: (left - 20) + 'px',
            'top': (calcTop + 25) + 'px'
          })
        }
      }
    } else {
      if ((po.array[0].clientWidth + el.offsetLeft) > window.innerWidth) {
        po.css({
          left: (window.innerWidth - po.array[0].clientWidth - 20) + 'px',
          'top': (calcTop) + 25 + 'px'
        })
      } else {
        po.css({
          left: left + 'px',
          'top': (calcTop + 25) + 'px'
        })
      }
    }
  },

  closePopover: () => {
    var popover = document.querySelector('ui-popover.opened')
    if (!popover) return
    $.unblock()
    popover.classList.remove('opened')
    popover.style.display = 'none'
  }
})
$(() => {
  window.onresize = () => {
    const popover = document.querySelector('ui-popover.opened')
    if (popover) {
      const trigger = document.querySelector('ui-popover.opened').dataset.triggerEl
      $.positionPopover(trigger)
    }
  }
  $('body').on($.eventStart, 'ui-mask', e => {
    $.closePopover()
  })
})


class UIPopup {
  constructor(options) {

    if (!options) return
    let settings = {}
    settings.id = $.uuid()
    settings.content = true
    $.extend(settings, options)
    let width = ''
    if (settings.width) {
      width = `style="width:${settings.width}px"`
    }

    const id = settings.id
    const title = settings.title ? `<header><h1>${settings.title}</h1></header>` : ''
    const message = settings.message ? `<p role="note">${options.message}</p>` : ''
    const cancelButton = options.cancelButton ? `<button class="cancel" role="button">${settings.cancelButton}</button>` : ''
    const continueButton = settings.continueButton ? `<button class="continue" role="button">${settings.continueButton}</button>` : ''
    const callback = settings.callback || $.noop
    let popup
    if (settings.empty) {
      popup = `<div id="${id}" class="popup"><div ${width} class="dialog" role="alertdialog"></div></div>`
    } else {
      popup = `<div class="popup" id="${id}"><div class="dialog" role="alertdialog"><div class="panel">${title}${message}</div><footer>${cancelButton}${continueButton}</footer></div></div>`
    }
    function closePopup(popup) {
      popup.classList.remove('opened')
    }
    $('body').append(popup)
    if (settings.empty) {
      $('.dialog').css({
        "display": "-webkit-flex",
        "-webkit-justify-content": "center",
        "-webkit-align-items": "center",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center"
      })
    }
    this.close = function() {
      const popup = document.getElementById(settings.id)
      if (popup) popup.classList.remove('opened')
    }
    if (callback && continueButton) {
      $('#' + id).find('.continue').on('tap', function () {
        const self = this
        if ($.isAndroid || $.isChrome) {
          self.classList.add('selected')
          setTimeout(function () {
            self.classList.remove('selected')
            $('.popup').ClosePopup()
            callback.call(callback)
          }, 300)
        } else {
          closePopup($(this).closest('.popup').array[0])
          callback.call(callback)
        }
      })
    }
    $('#' + id).find('.cancel').on('tap', function () {
      const popup = $(this).closest('.popup').array[0]
      const self = this
      if ($.isAndroid || $.isChrome) {
        self.classList.remove('selected')
        setTimeout(function () {
          self.classList.remove('selected')
          closePopup(popup)
        }, 300)
      } else {
          closePopup(popup)
      }
    })

    $(function() {
      $('.popup').on('tap', function (e) {
        this.classList.remove('opened')
      })
    })

    this.open = () => {
      const popup = document.getElementById(settings.id)
      if (popup) {
        popup.classList.remove('forPopup')
        popup.classList.add('opened')
      }
    }
  }
}


class UIRange {
  constructor(range) {
    function _range(input) {
      if (!input || input.nodeName !== 'INPUT') return
      let newPlace
      const width = input.clientWidth
      const newPoint = (input.value - input.getAttribute("min")) / (input.getAttribute("max") - input.getAttribute("min"))
      let offset = -1.3
      if (newPoint < 0) {
        newPlace = 0
      } else if (newPoint > 1) {
        newPlace = width
      } else {
        newPlace = width * newPoint + offset
        offset -= newPoint
      }
      if ($.theme  && $.theme === 'android') {
        $(input).css({
          'background-size': Math.round(newPlace) + 'px 3px, 100% 3px'
        })
      } else {
        $(input).css({
          'background-size': Math.round(newPlace) + 'px 10px'
        })
      }
    }
    setTimeout(() => {
      const ranges = $('input[type=range]')
      if (ranges.array.length) {
        ranges.array.forEach(ctx => {
          _range(ctx)
        })
      }
    })
    $('body').on('input', 'input[type=range]', function() {
      _range(this)
    })
    if (range) {
      $(() => {
        _range(range)
      })
    }
  }
}


$.extend({
  ChuiRoutes: []
})
class Router {
  constructor() {}

  addRoute(...options) {
    options.forEach(item => $.subscribe(item.route, item.callback));
  }
  static dispatch(route) {
    if (!route) return
    let temp
    let id
    if (route.match(/\:/)) {
      temp = route.split(':')
      id = temp[1]
      route = temp[0]
    }
    $.publish(route, id)
  }
}

$.extend($.ChuiRoutes, {
  getFullRoute: function getFullRoute() {
    return this.join('/')
  }
})

$(() => {
  if ($('ui-screen').array.length && !$.ChuiRoutes.length) {
    $.ChuiRoutes.push($('ui-screen').array[0].id)
  }
})


class UISegmented {
  constructor(options) {
    if (!options || !options.element) return
    const self = this
    let settings = {
      selected: 0,
      callback: $.noop
    }
    $.extend(settings, options)

    this.button
    let segmented
    const labels = (settings.labels) ? settings.labels : []
    this.index
    this.element = settings.element

    function createSegmentedButton() {
      let androidSelectionIndicator = ''
      if ($.theme = 'android') {
        androidSelectionIndicator = '<span class="androidSelectionBorder"></span>'
      }
      let __segmented = ['<ui-segmented>']
      labels.forEach(function(ctx, idx) {
        if (settings.selected === idx) {
          __segmented.push('<button role="radio" aria-checked="true" class="selected">')
          self.index = idx
        } else {
          __segmented.push('<button role="radio">')
        }

        __segmented.push(ctx)
        __segmented.push('</button>')
      })
      __segmented.push(androidSelectionIndicator + '</ui-segmented>')
      segmented = __segmented.join('')
      $(settings.element).append(segmented)
      self.button = $(settings.element).find('button').eq(settings.selected).array[0]



    }
    createSegmentedButton()

    /**
     * For Android Material Design:
     */
    let androidSelectionBorder
    if ($.theme === 'android') {
      androidSelectionBorder = $(this.element).find('.androidSelectionBorder')
      let selectedButton = $(this.element).find('button').eq(settings.selected)
      let width = selectedButton.array[0].clientWidth
      let left = selectedButton.array[0].offsetLeft
      androidSelectionBorder.css({width: width + 'px', left: left + 'px'})
    }

    const callback = settings.callback
    $(this.element).on('tap', 'ui-segmented > button', function(e) {
      if (this.parentNode.classList.contains('paging')) return
      $(this).siblings('button').array.map(btn => btn.classList.remove('selected'))
      $(this).siblings('button').array.map(btn => btn.removeAttribute('aria-checked'))
      this.classList.add('selected')
      self.index = $(this).index()
      self.button = this
      this.setAttribute('aria-checked', true)
      callback.call(this, e)

      /**
       * For Android Material Design:
       */
      if ($.theme === 'android') {
        let width = this.clientWidth
        let left = this.offsetLeft
        if (document.dir === 'rtl') {
          left = this.offsetLeft
        }
        androidSelectionBorder.css({width: width + 'px', left: left + 'px'})
      }
    })
  }
}


class UISelectList {
  constructor(options) {
    if (!options || !options.element) return
    var self = this
    let settings = {
      element: undefined,
      selected: undefined,
      name: $.uuid(),
      callback: $.noop,
      state: undefined,
      render: undefined,
      value: undefined,
    }
    $.extend(settings, options)
    this.value = settings.value
    this.index = settings.selected
    const name = settings.name
    this.root = $(settings.element)

    const selectionIndicator = function(value) {
      return `
        <input type='radio' value='${value}' name='${settings.name}'><aside>
        <span class="selection-indicator">
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="selection-indicator">
                <path d="M2,13 L9.9294326,16.8406135 L17.1937075,1.90173332" id="checkmark" stroke="#007AFF" stroke-width="2"></path>
                <circle id="outer-circle" stroke="#007AFF" stroke-width="2" cx="10" cy="10" r="9"></circle><circle id="inner-circle" fill="#007AFF" cx="10" cy="10" r="5"></circle>
              </g>
            </g>
          </svg>
        </span>
      </aside>
      `
    }
    if (settings.state) {
      settings.state.boundComponents.push(this)
    }
    let settingsData
    if (settings.state) settingsData = settings.state.dataStore
    this.value = settingsData ? settingsData[settings.selected].value : ''
    this.index = settings.selected

    this.render = function(data, append) {
      var temp = ''
      if (!settings.element) {
        return
      }

      if (!data && settings.state) {
        data = settings.state.dataStore
      }

      if (Array.isArray(data)) {
        data.map(function(item) {
          temp += settings.render(item)
        }).join('')
      } else {
        return
      }

      this.root.textContent = ''
      var root = $(settings.element)
      root.empty()
      root.append(temp)
      setTimeout(function() {
        var data = settings.state.dataStore
        var listItems = Array.prototype.slice.apply(root[0].querySelectorAll('li'))
        listItems.map((item, idx) => {
          $(item).append(selectionIndicator(data[idx].value, idx))
          if (idx == settings.selected) {
            item.classList.add('selected')
            $(item).find('input')[0].checked = true
          }
        })
      })
    }

    $(settings.element).on('tap', 'li', function() {
      const item = $(this)
      self.value = this.querySelector('input').value
      self.index = item.index()

      var siblings = item.siblings('li')
      siblings.forEach(function(sib) {
        sib.removeAttribute('aria-checked')
        sib.classList.remove('selected')
        sib.querySelector('input').checked = false
      })
      this.classList.add('selected')
      this.setAttribute('aria-checked', true)
      this.querySelector('input').checked = true
      settings.callback.apply(this, arguments)
    })
  }
}


class UISheet {
  constructor(options) {
    if (!options) return
    /**
      var options {
        id : 'starTrek',
        background: 'transparent',
        handle: false,
        slideDown: false // default is slideUp
      }
    */
    if (!options) return
    let settings = {
      id: $.uuid(),
      background: '',
      handle: true,
      slideFrom: ''
    }

    $.extend(settings, options)

    if (settings.background) settings.background = ' style="background-color:' + settings.background + '" '
    if (settings.slideFrom === 'top') {
      settings.slideDown = ` class="slideDown" `
    } else {
      settings.slideFrom = ' '
    }
    if (settings.handle === false) settings.handle = ''
    else settings.handle =
      `<ui-sheet-handle>
        <svg width="100%" height="100%" viewBox="0 0 76 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:butt;stroke-linejoin:butt;stroke-miterlimit:1.41421;">
          <g id="sheet-handle" transform="matrix(1,0,0,1,-29.7966,-15.7797)">
            <path id="sheet-handle-path" d="M36.25,26.242L67.645,34.215L98.176,25.789" style="fill:none;"/>
          </g>
        </svg>
      </ui-sheet-handle>`

    const sheet = `<ui-sheet id="${ settings.id }" ${ settings.slideDown } ${ settings.background }>${ settings.handle }<section></section></ui-sheet>`

    $('body').append(sheet)

    $('#' + settings.id).find('ui-sheet-handle').on($.eventStart, () => {
      $('#' + settings.id).array[0].classList.remove('opened')
      document.querySelector('ui-screen.current').classList.remove('blurred')
    })

    this.show = () => {
      let sheet = document.getElementById(settings.id)
      document.querySelector('ui-screen.current').classList.add('blurred')
      sheet.classList.add('opened')
      if ($.isAndroid || $.isChrome) {
        sheet.style.display = 'block'
        setTimeout(function() {
          sheet.classList.add('opened')
        }, 20)
      } else {
        sheet.classList.add('opened')
      }
    }

    this.hide = () => {
      $('#' + settings.id).array[0].classList.remove('opened')
      document.querySelector('ui-screen.current').classList.remove('blurred')
    }

    this.populate = (template) => $('#' + settings.id).find('section').append(template)
  }
}


class UISlideOut {
  constructor(id) {
    const slideoutID = id || $.uuid()
    this.id = slideoutID
    const buttonID = 'slideoutBtnID1234'
    const slideOutButton = `<button id="${ buttonID }" class="slide-out-button"></button>`
    const slideOut = `<ui-slideout id="${ slideoutID }"><section></section></ui-slideout>`
    $('body').prepend(slideOut)
    $('body').append(slideOutButton)
    /**
     * Get Slide Out & Slide Out button:
     */
    let slideout = document.getElementById(slideoutID)
    let slideOutBtn = document.getElementById(buttonID)

    /**
     * Set up state for Slide Out and screens:
     */
    slideout.setAttribute('aria-hidden', true)
    $('ui-screen').forEach(screen => {
      screen.setAttribute('aria-hidden', true)
    })
    document.querySelector('ui-screen').classList.add('show')
    document.querySelector('ui-screen').setAttribute('aria-hidden', "false")


    /**
     * Handle Slide Out button events:
     */
    $('#'+buttonID).on('tap', function() {
      this.classList.toggle('focused')
      slideout.classList.toggle('open')
      if (slideout.classList.contains('open')) {
        $.block('.5')
      } else {
        $.unblock()
      }
    })

    $(slideout).on('tap', 'li', function() {
      let menuItems = $(slideout).find('li[data-show]')
      slideout.setAttribute('aria-hidden', 'true')
      $.unblock()

      /**
       * Toggle Slide Out button:
       */
      slideOutBtn.classList.toggle('focused')
      while ($.ChuiRoutes.length > 1) {
        $.GoBack()
      }

      /**
       * This list item shows a single screen:
       */
      menuItems.forEach(item => {
        if (item.classList.contains('selected')) {
          item.classList.remove('selected')
        }
      })
      const shownScreen = document.querySelector('ui-screen.show')
      shownScreen.classList.remove('show')
      shownScreen.setAttribute('aria-hidden', true)
      const screenToShow = '#' + this.dataset.show.split(':')[0]
      /**
       * Account for presence of navigation list state:
       */
      setTimeout(function() {
        document.querySelector(screenToShow).classList.remove('next')
      }, 200)
      document.querySelector(screenToShow).classList.add('show')
      // console.log()
      Router.dispatch(this.dataset.show)
      /**
       * Close slide out:
       */
      slideout.classList.remove('open')
    })
  }

  populate(options) {
    if (!options) return
    const slideout = document.getElementById(this.id)
    if (!options) {
      return
    } else {
      slideout.querySelector('section').appendChild($.h('<ul class="list"></ul>'))
      let list = slideout.querySelector('ul')
      options.forEach(ctx => {
        for (let key in ctx) {
          if (key === 'header') {
            $(list).append('<li class="menu-header"><h2>' + ctx[key] + '</h2></li>')
          } else {
            $(list).append('<li data-show="' + key + '"><h3>' + ctx[key] + '</h3></li>')
          }
        }
      })
    }
  }
}


class UIStepper {
  constructor(options) {
    if (!options || !options.element || !options.min || !options.max) return
    var self = this
    this.stepper = $(options.element)
    const min = options.min
    const max = options.max
    const defaultValue = options.defaultValue ? options.defaultValue : options.min
    let increaseSymbol = '+'
    let decreaseSymbol = '-'
    let disabledDecrease = ''
    let disabledIncrease = ''
    this.value
    if (min === defaultValue) {
      disabledDecrease = ' disabled '
    } else if (max === defaultValue) {
      disabledIncrease = ' disabled '
    }
    const decreaseButton = '<button ' + disabledDecrease + ' class="decrease"><span>-</span></button>'
    const label = `<label>${ defaultValue }</label><input type="text" value="${ defaultValue }">`
    const increaseButton = '<button ' + disabledIncrease + '  class="increase"><span>+</span></button>'
    $(options.element).append(decreaseButton + label + increaseButton)
    var dataVal = {
      min: min,
      max: max,
      defaultValue: defaultValue
    }
    $(options.element).array[0].dataset.value = JSON.stringify(dataVal)

    const increaseStepperValue = function() {
      const currentValue = $(options.element).find('input').array[0].value
      const value = JSON.parse($(options.element).array[0].dataset.value)
      const max = value.max
      let newValue
      newValue = parseInt(currentValue, 10) + 1
      $(options.element).find('button:first-of-type').array[0].removeAttribute('disabled')
      $(options.element).find('label').text(newValue)
      $(options.element).find('input').array[0].value = newValue
      self.value = newValue
      if (newValue == max) {
        this.setAttribute('disabled', 'disabled')
      }
    }

    const decreaseStepperValue = function() {
      const currentValue = $(options.element).find('input').array[0].value
      const value = JSON.parse($(options.element).array[0].dataset.value)
      let newValue
      newValue = parseInt(currentValue, 10) - 1
      $(options.element).find('button:last-of-type').array[0].removeAttribute('disabled')
      $(options.element).find('label').text(newValue)
      $(options.element).find('input').array[0].value = newValue
      self.value = newValue
      if (newValue === min) {
        this.setAttribute('disabled', 'disabled')
      }
    }

    $(options.element).find('button:last-of-type').on($.eventStart, function() {
      increaseStepperValue.call(this, this.__stepper)
    })

    $(options.element).find('button:first-of-type').on($.eventStart, function() {
      decreaseStepperValue.call(this, this.__stepper)
    })
  }
}


class UISwitch {
  constructor(options) {
    if (!options || !options.element) return
    this.checked = false
    this.value = undefined
    const self = this
    let settings = {
      element: undefined,
      name: undefined,
      value: undefined,
      checked: false,
      on: $.noop,
      off: $.noop
    }
    $.extend(settings, options)
    this.checked = settings.checked
    this.value = settings.value
    let __element = $(settings.element)
    let __el = __element.array[0]
    /**
     * Abrstract swipe for left-to-right and right-to-left:
     */
    let swipeOn = "swiperight"
    let swipeOff = "swipeleft"
    if (document.documentElement.dir === "rtl") {
      swipeOn = "swipeleft"
      swipeOff = "swiperight"
    }

    let checkState = settings.checked ? ' checked' : ''
    const __switch = `<em></em><input type="checkbox" name="${ settings.name }" ${ checkState } value="${ settings.value }">`

    __element.append(__switch)
    __el.value =  settings.value
    __el.setAttribute('name', settings.name)

    if (this.checked) {
      __el.classList.add('checked')
      __el.setAttribute('role', 'checkbox')
      __el.checked = true
    }



    __element.on('tap', function() {
      const checkbox = this.querySelector('input')
      if (this.classList.contains('checked')) {
        this.classList.remove('checked')
        this.setAttribute('aria-checked', false)
        checkbox.removeAttribute('checked')
        this.checked = false
        self.checked = false
        __el.checked = false
        if (settings.off) {
          settings.off.call(this)
        }
      } else {
        this.classList.add('checked')
        checkbox.setAttribute('checked', 'checked')
        __el.checked = true
        this.setAttribute('aria-checked', true)
        this.checked = true
        self.checked = true
        if (settings.on) {
          settings.on.call(this)
        }

      }
    })
    __element.on(swipeOn, function() {
      const checkbox = this.querySelector('input')
      if (this.classList.contains('checked')) {
        this.classList.remove('checked')
        this.setAttribute('aria-checked', false)
        __el.checked = false
        checkbox.removeAttribute('checked')
        this.checked = true
        self.checked = true
        if (settings.on) {
          settings.on.call(this)
        }
      }
    })
    __element.on(swipeOff, function() {
      const checkbox = this.querySelector('input')
      if (!this.classList.contains('checked')) {
        this.classList.add('checked')
        checkbox.setAttribute('checked', 'checked')
        this.setAttribute('aria-checked', true)
        __el.checked = true
        this.checked = false
        self.checked = false
        if (settings.off) {
          settings.off.call(this)
        }
      }
    })
  }
}


class UITabbar {
  constructor(options) {
    if (!options) return
    let id = $.uuid()
    let settings = {
      selected: 0
    }
    $.extend(settings, options)
    if (!settings.icons.length) {
      settings.icons = settings.labels
    }
    if (!settings.id) {
      settings.id = id
    } else {
      id = settings.id
    }

    /* Private variable to keep track of screens. */
    let __tabbarScreens = new Stack()

    let screens = new Stack()
    const screenPrefix = '#'

    if (settings.screens) {
      settings.screens.forEach(function (screen, idx) {
        if (!/screenPrefix/img.test(screen)) {
          __tabbarScreens.push(document.getElementById(screen))
          __tabbarScreens.array[idx].classList.add('tabScreen')
        } else {
          __tabbarScreens.concat($(ui-screen))
          $(screen).array[0].classList.add('tabScreen')
        }
      })
    } else {
      settings.labels.forEach(function (screen, idx) {
        __tabbarScreens.push(screens.eq(idx))
      })
    }
    let selectedScreen
    let androidSelectionIndicator = ''
    if ($.theme === 'android') {
      androidSelectionIndicator = '<span class="androidSelectionBorder"></span>'
    }
    const showIcons = settings.showIcons ? ' class="showIcons" ' : ''

    /* Create tabs. */
    const makeTab = (label, icon, idx) => {
      let tab = '<button role="tab" class="' + icon
      if (settings.selected === idx) {
        tab += ' selected'
        $.ChuiRoutes = [settings.screens[idx]]
      }
      tab += '"'
      if (settings.screens && settings.screens.length) {
        tab += ` data-id="${ settings.screens[idx] }" data-chui-route="${ settings.screens[idx] }"`
      }
      tab += `><span class="icon"></span><label>${ settings.labels[idx] }</label></button>`
      return tab
    }
    /* Create tab bar. */
    let tabbarTmpl = document.createElement('ui-tabbar')
    tabbarTmpl.role = "tabpanel"
    if (settings.showIcons) tabbarTmpl.classList.add('showIcons')
    tabbarTmpl.insertAdjacentHTML('beforeend', androidSelectionIndicator)
    tabbarTmpl.id = settings.id
    window.tabbarTmpl = tabbarTmpl

    if (settings.labels.length) {
      settings.labels.forEach(function (label, idx) {
        var tab = makeTab(label, settings.icons[idx], idx)
        tabbarTmpl.appendChild($.h(tab))
      })
    }

    /* Append tabbar to page. */
    $('body').prepend(tabbarTmpl)

    /* Get id of appended tab bar. */
    const tabbar = $('#' + settings.id)
    const selectedTabButton = tabbar.find('button.selected')


    /* Private variables to manage tab bar. */
    const __tabbarButtons = tabbar.find('button')
    const __selectedTabbarButton = __tabbarButtons.eq(settings.selected)
    const __selectedTabbarScreen = __tabbarScreens.eq(settings.selected)

    /* For Android Material Design. */
    const androidSelectionBorder = tabbar.find('.androidSelectionBorder')
    function handleTabSelectionForAndroid(tab) {
      let width = tab.clientWidth
      let left = tab.offsetLeft
      androidSelectionBorder.css({width: width + 'px', left: left + 'px'})
    }
    if ($.theme === 'android') {
      $(function() {
        console.dir(selectedTabButton)
        handleTabSelectionForAndroid(selectedTabButton.array[0])

      })
    }

    this.getSelectedTab = () => {
      return __selectedTabbarButton
    }

    this.getSelectedScreen = () => {
      return __selectedTabbarScreen
    }

    /* Setup events on tabs. */
    $(() => {

      const tabbarButtons = tabbar.find('button')

      /* Tap on tab. */
      tabbar.on('tap', 'button', function () {
        const tab = this
        const routes = tab.dataset.chuiRoute.split('/')
        const fullRoute = $.ChuiRoutes.join('/')
        let navRoutesFull = tab.dataset.chuiRoute
        const navRoutes = navRoutesFull.split('/')
        const rr = $.ChuiRoutes

        /* This tab holds a navigation list. */
        var currBtn = document.querySelector('ui-tabbar button.selected')
        currBtn.classList.remove('selected')
        currBtn.dataset.chuiRoute = fullRoute
        this.classList.add('selected')
        if (navRoutes.length > 1) {
          navRoutesFull = tab.dataset.chuiRoute

          const navRoutes = navRoutesFull.split('/')

          const currScreen = document.querySelector('ui-screen.current')
          if (currScreen) {
            currScreen.classList.remove('current')
            currScreen.classList.add('next')
          }
          const prevScreen = document.querySelector('ui-screen.previous')
          if (prevScreen) {
            prevScreen.classList.remove('previous')
            prevScreen.classList.add('next')
          }

          navRoutes.forEach( (route, idx) => {
            const routing = route.split(':')
            let whichRoute = routing[0]
            let screen = document.getElementById(whichRoute)
            if (idx !== routes.length - 1) {
              screen.classList.remove('next')
              screen.classList.add('previous')
              screen.setAttribute('aria-hidden', true)
            } else {
              screen.classList.remove('next')
              screen.classList.add('current')
              screen.setAttribute('aria-hidden', false)
            }
          })

          /* Take care of routes. */
          $.ChuiRoutes = routes
          Router.dispatch(routes[routes.length - 1])

          /* Handle Android ripple effect. */
          if ($.theme === 'android') {
            handleTabSelectionForAndroid(tab)
          }

          /* This tab has a single screen. */
        } else {
          const screen = $('ui-screen').eq($(tab).index())

          /* Deal with previously selected tab and screen. */
          const currScreen =  document.querySelector('ui-screen.current')
          if (currScreen) {
            currScreen.classList.remove('current')
            currScreen.classList.add('next')
            currScreen.setAttribute('aria-hidden', true)
          }
          const prevScreen = document.querySelector('ui-screen.previous')

          if (prevScreen) {
            prevScreen.classList.remove('previous')
            prevScreen.classList.add('next')
            prevScreen.setAttribute('aria-hidden', true)
          }

          /* Set this tab to `selected`. */
          tab.classList.add('selected')
          if ($.theme === 'android') {
            handleTabSelectionForAndroid(tab)
          }

          routes.forEach( (route, idx) => {
            const routing = route.split(':')
            const whichRoute = routing[0]
            const wr = document.getElementById(whichRoute)
            if (idx !== routes.length - 1) {
              wr.classList.remove('next')
              wr.classList.add('previous')
              wr.setAttribute('aria-hidden', true)

            } else {
              if (wr) {
                wr.classList.remove('next')
                wr.classList.add('current')
                wr.setAttribute('aria-hidden', false)
              } else {
              }
            }
          })

          /* Take care of routes. */
          $.ChuiRoutes = routes
          Router.dispatch(fullRoute)
        }
      })

      $('ui-screen').eq(settings.selected).array[0].classList.remove('next')
      $('ui-screen').eq(settings.selected).array[0].classList.add('current')
    })

  }
}



// const UITabbar = (() => {
//   /* Creates a Tab Bar for Toggling Articles. */
//   function _tabBar(options) {
//     /**
//     var options = {
//       id: 'mySpecialTabbar',
//       labels: ["Refresh", "Add", "Info", "Downloads", "Favorite"],
//       icons: ["refresh", "add", "info", "downloads", "favorite"],
//       screens: [],
//       selected: 2,
//       showIcons: false // set to true to show icons for Android
//     }
//     */
//     if (!options) return
//     let id = $.uuid()
//     let settings = {
//       selected: 0
//     }
//     $.extend(settings, options)
//     if (!settings.icons.length) {
//       settings.icons = settings.labels
//     }
//     if (!settings.id) {
//       settings.id = id
//     } else {
//       id = settings.id
//     }

//     /* Private variable to keep track of screens. */
//     let __tabbarScreens = new Stack()

//     let screens = new Stack()
//     const screenPrefix = '#'

//     if (settings.screens) {
//       settings.screens.forEach(function (screen, idx) {
//         if (!/screenPrefix/img.test(screen)) {
//           __tabbarScreens.push(document.getElementById(screen))
//           __tabbarScreens.array[idx].classList.add('tabScreen')
//         } else {
//           __tabbarScreens.concat($(ui-screen))
//           $(screen).array[0].classList.add('tabScreen')
//         }
//       })
//     } else {
//       settings.labels.forEach(function (screen, idx) {
//         __tabbarScreens.push(screens.eq(idx))
//       })
//     }
//     let selectedScreen
//     let androidSelectionIndicator = ''
//     if ($.theme === 'android') {
//       androidSelectionIndicator = '<span class="androidSelectionBorder"></span>'
//     }
//     const showIcons = settings.showIcons ? ' class="showIcons" ' : ''

//     /* Create tabs. */
//     const makeTab = (label, icon, idx) => {
//       let tab = '<button role="tab" class="' + icon
//       if (settings.selected === idx) {
//         tab += ' selected'
//         $.ChuiRoutes = [settings.screens[idx]]
//       }
//       tab += '"'
//       if (settings.screens && settings.screens.length) {
//         tab += ` data-id="${ settings.screens[idx] }" data-chui-route="${ settings.screens[idx] }"`
//       }
//       tab += `><span class="icon"></span><label>${ settings.labels[idx] }</label></button>`
//       return tab
//     }
//     /* Create tab bar. */
//     let tabbarTmpl = document.createElement('ui-tabbar')
//     tabbarTmpl.role = "tabpanel"
//     if (settings.showIcons) tabbarTmpl.classList.add('showIcons')
//     tabbarTmpl.insertAdjacentHTML('beforeend', androidSelectionIndicator)
//     tabbarTmpl.id = settings.id
//     window.tabbarTmpl = tabbarTmpl

//     if (settings.labels.length) {
//       settings.labels.forEach(function (label, idx) {
//         var tab = makeTab(label, settings.icons[idx], idx)
//         tabbarTmpl.appendChild($.h(tab))
//       })
//     }

//     /* Append tabbar to page. */
//     $('body').prepend(tabbarTmpl)

//     /* Get id of appended tab bar. */
//     const tabbar = $('#' + settings.id)
//     const selectedTabButton = tabbar.find('button.selected')


//     /* Private variables to manage tab bar. */
//     const __tabbarButtons = tabbar.find('button')
//     const __selectedTabbarButton = __tabbarButtons.eq(settings.selected)
//     const __selectedTabbarScreen = __tabbarScreens.eq(settings.selected)

//     /* For Android Material Design. */
//     const androidSelectionBorder = tabbar.find('.androidSelectionBorder')
//     function handleTabSelectionForAndroid(tab) {
//       let width = tab.clientWidth
//       let left = tab.offsetLeft
//       androidSelectionBorder.css({width: width + 'px', left: left + 'px'})
//     }
//     if ($.theme === 'android') {
//       $(function() {
//         console.dir(selectedTabButton)
//         handleTabSelectionForAndroid(selectedTabButton.array[0])

//       })
//     }

//     this.getSelectedTab = () => {
//       return __selectedTabbarButton
//     }

//     this.getSelectedScreen = () => {
//       return __selectedTabbarScreen
//     }

//     /* Setup events on tabs. */
//     $(() => {

//       const tabbarButtons = tabbar.find('button')

//       /* Tap on tab. */
//       tabbar.on('tap', 'button', function () {
//         const tab = this
//         const routes = tab.dataset.chuiRoute.split('/')
//         const fullRoute = $.ChuiRoutes.join('/')
//         let navRoutesFull = tab.dataset.chuiRoute
//         const navRoutes = navRoutesFull.split('/')
//         const rr = $.ChuiRoutes

//         /* This tab holds a navigation list. */
//         var currBtn = document.querySelector('ui-tabbar button.selected')
//         currBtn.classList.remove('selected')
//         currBtn.dataset.chuiRoute = fullRoute
//         this.classList.add('selected')
//         if (navRoutes.length > 1) {
//           navRoutesFull = tab.dataset.chuiRoute

//           const navRoutes = navRoutesFull.split('/')

//           const currScreen = document.querySelector('ui-screen.current')
//           if (currScreen) {
//             currScreen.classList.remove('current')
//             currScreen.classList.add('next')
//           }
//           const prevScreen = document.querySelector('ui-screen.previous')
//           if (prevScreen) {
//             prevScreen.classList.remove('previous')
//             prevScreen.classList.add('next')
//           }

//           navRoutes.forEach( function(route, idx) {
//             const routing = route.split(':')
//             let whichRoute = routing[0]
//             let screen = document.getElementById(whichRoute)
//             if (idx !== routes.length - 1) {
//               screen.classList.remove('next')
//               screen.classList.add('previous')
//               screen.setAttribute('aria-hidden', true)
//             } else {
//               screen.classList.remove('next')
//               screen.classList.add('current')
//               screen.setAttribute('aria-hidden', false)
//             }
//           })

//           /* Take care of routes. */
//           $.ChuiRoutes = routes
//           Router.dispatch(routes[routes.length - 1])

//           /* Handle Android ripple effect. */
//           if ($.theme === 'android') {
//             handleTabSelectionForAndroid(tab)
//           }

//           /* This tab has a single screen. */
//         } else {
//           const screen = $('ui-screen').eq($(tab).index())

//           /* Deal with previously selected tab and screen. */
//           const currScreen =  document.querySelector('ui-screen.current')
//           if (currScreen) {
//             currScreen.classList.remove('current')
//             currScreen.classList.add('next')
//             currScreen.setAttribute('aria-hidden', true)
//           }
//           const prevScreen = document.querySelector('ui-screen.previous')

//           if (prevScreen) {
//             prevScreen.classList.remove('previous')
//             prevScreen.classList.add('next')
//             prevScreen.setAttribute('aria-hidden', true)
//           }

//           /* Set this tab to `selected`. */
//           tab.classList.add('selected')
//           if ($.theme === 'android') {
//             handleTabSelectionForAndroid(tab)
//           }

//           routes.forEach(function (route, idx) {
//             const routing = route.split(':')
//             const whichRoute = routing[0]
//             const wr = document.getElementById(whichRoute)
//             if (idx !== routes.length - 1) {
//               wr.classList.remove('next')
//               wr.classList.add('previous')
//               wr.setAttribute('aria-hidden', true)

//             } else {
//               if (wr) {
//                 wr.classList.remove('next')
//                 wr.classList.add('current')
//                 wr.setAttribute('aria-hidden', false)
//               } else {
//               }
//             }
//           })

//           /* Take care of routes. */
//           $.ChuiRoutes = routes
//           Router.dispatch(fullRoute)
//         }
//       })

//       $('ui-screen').eq(settings.selected).array[0].classList.remove('next')
//       $('ui-screen').eq(settings.selected).array[0].classList.add('current')
//     })
//   }

//   return _tabBar
// })()
